const ClockingType = {

  CLOCKING_EXTENDED: 'clockingExtended',

  CLOCKING_WORKER: 'clockingWorker',

  CLOCKING_LINE_ITEMS: 'clockingLineItems'

}

export default ClockingType



// WEBPACK FOOTER //
// ./src/infra/ClockingType.js